import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getBrandImageUrl } from 'ck-utils';
import { Button } from 'ck-ui';
import layout from 'ck-utils/layout.module.scss';
import styles from './SearchBar.module.scss';

const getBrandHandle = brandUrl => brandUrl.split('/').slice(-1)[0];

const SearchBarBrands = ({ brands, onBrandClick }) => (
  <>
    <div className="columns is-mobile is-multiline is-variable is-1">
      {brands.map((brand, index) => (
        <div
          key={brand.title}
          className={classnames('column is-4-touch is-6-desktop', styles.brand, {
            'is-hidden-desktop': index > 5 // desktop only shows 6
          })}
        >
          <a className={styles.brandLink} href={brand.url} onClick={onBrandClick(brand.url)}>
            <img alt={brand.title} src={getBrandImageUrl(getBrandHandle(brand.url), 'centre')} />
          </a>
        </div>
      ))}
    </div>
    <Button
      renderAs="a"
      href="/collections/brands"
      onClick={onBrandClick('/collections/brands')}
      fullwidth="all"
      className={classnames(layout.marginTopLarge, 'is-hidden-touch')}
    >
      View all brands
    </Button>
  </>
);

SearchBarBrands.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired
  })).isRequired,
  onBrandClick: PropTypes.func.isRequired
};

export { SearchBarBrands };
